import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import PassoDatas, {
  type PassoDatasHandle,
} from '@/pages/assistente-evento/components/PassoDatas';

interface Props {
  eventoId: number;
  cidade: string;
  mostrarPresencas: boolean;
  aoFechar: () => void;
  aoSalvo: () => void;
}

export default function EncontrosEditor({
  eventoId,
  cidade,
  mostrarPresencas,
  aoFechar,
  aoSalvo,
}: Props) {
  const ref = useRef<PassoDatasHandle>(null);
  const navigate = useNavigate();

  return (
    <div className="space-y-5">
      <PassoDatas ref={ref} eventoId={eventoId} cidade={cidade} aoPular={aoFechar} />

      {mostrarPresencas && (
        <button
          type="button"
          onClick={() => navigate(`/gerenciar/${eventoId}/direcao?aba=presencas`)}
          className="flex w-full cursor-pointer items-center justify-between gap-2 rounded-lg border border-secondary-200 bg-white px-4 py-3 text-left transition-colors hover:bg-background-50"
        >
          <span className="flex items-center gap-2 text-sm font-medium text-foreground-900">
            <span className="flex h-5 w-5 items-center justify-center text-primary-600">
              <i className="ri-calendar-check-line" />
            </span>
            Ver presenças
          </span>
          <span className="flex h-5 w-5 items-center justify-center text-secondary-400">
            <i className="ri-arrow-right-s-line text-xl" />
          </span>
        </button>
      )}

      <div className="sticky bottom-0 -mx-5 flex gap-2 border-t border-secondary-100 bg-white px-5 py-3">
        <button
          type="button"
          onClick={() => {
            aoSalvo();
            aoFechar();
          }}
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-600"
        >
          Concluir
        </button>
      </div>
    </div>
  );
}